export const environment = {
  production: false,
  apiUrl: "https://dev.substrata.s-cube.com/api/v1",
  apiUrl_v2: "https://dev.substrata.s-cube.com/api/v2",
  apiUrl_copilot: "https://dev.substrata.s-cube.com/api/v1",
  is_aws_default: true,
  auth0: {
    clientId: "yJMkUVlKyK30jsGrY9WVQQrpcCrVcaxh",
    domain: "scube.eu.auth0.com",
    audience: "https://aws-dev01.substrata.s-cube.com",
    scope: "openid email",
  },
  stripeKey: "pk_live_kEKNpjDgbUKvCX96SsBPv19h",
};
